const HeaderNoticias = ({children}) => {
    return (<div className="gris g-blog" >
        {children}
    </div>)
}

export default HeaderNoticias;